var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal", {
    ref: "modal",
    staticClass: "modal-background changelog-latest-modal",
    attrs: { "body-class": "h-auto" },
    on: { "modal-close": _vm.onClose },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_vm._v(" Zmiany w systemie Dostartu ")]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.entry
              ? _c("changelog-entry-item", {
                  attrs: {
                    entry: _vm.entry,
                    variant: "light",
                    "is-first": "",
                    "is-last": "",
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "base-button",
              { attrs: { btn2: "", short: "" }, on: { click: _vm.goToList } },
              [_vm._v(" Zobacz pełną listę zmian ")]
            ),
            _c(
              "base-button",
              { attrs: { btn1: "", short: "" }, on: { click: _vm.close } },
              [_vm._v(" ZAMKNIJ ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }